// extracted by mini-css-extract-plugin
export var closeButton = "_og-2";
export var closeButtonIcon = "_og-3";
export var lightboxContent = "_og-1";
export var lightboxOverlay = "_og-0";